import axios from 'axios';
import { Ciclo, Plano } from '@/utils/planos';

// Instância sem os interceptors do app (que exigem login do Keycloak)
const publico = axios.create();

export type DadosCadastro = { nome: string; email: string; celular: string; corretora: string; plano: Plano; ciclo: Ciclo; turnstile: string };

export const cadastrar = (dados: DadosCadastro) =>
  publico.post<{ empresa: string }>('/api/cadastro', dados).then(r => r.data);
